var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Icons/Close\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n        Created\n        with\n        Sketch.\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-Account-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eMedicare---Create-Acct---Medicare-Info---Part-A-Help-Drawer",
    transform: "translate(-971.000000, -31.000000)",
    fill: "#323A45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(612.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Close",
    transform: "translate(353.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6874718,17 L27.7667318,7.92073996 C28.0777561,7.60971575 28.0777561,7.10678297 27.7667318,6.79575876 L27.2042412,6.23326816 C26.893217,5.92224395 26.3902843,5.92224395 26.07926,6.23326816 L17,15.3125282 L7.92073996,6.2398857 C7.60971575,5.92886148 7.10678297,5.92886148 6.79575876,6.2398857 L6.23326816,6.8023763 C5.92224395,7.11340051 5.92224395,7.61633328 6.23326816,7.9273575 L15.3125282,17 L6.2398857,26.07926 C5.92886148,26.3902843 5.92886148,26.893217 6.2398857,27.2042412 L6.8023763,27.7667318 C7.11340051,28.0777561 7.61633328,28.0777561 7.9273575,27.7667318 L17,18.6874718 L26.07926,27.7667318 C26.3902843,28.0777561 26.893217,28.0777561 27.2042412,27.7667318 L27.7667318,27.2042412 C28.0777561,26.893217 28.0777561,26.3902843 27.7667318,26.07926 L18.6874718,17 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.e9ec1ae922e599e40bab4fd3ddf6dbfe.svg";
export { ForwardRef as ReactComponent };